import { createContext, useContext } from "react";

const ConversationContext = createContext(null);

export function ConversationProvider({ value, children }) {
  return (
    <ConversationContext.Provider value={value}>
      {children}
    </ConversationContext.Provider>
  );
}

export function useConversationContext() {
  const ctx = useContext(ConversationContext);
  if (!ctx) {
    throw new Error(
      "useConversationContext must be used within a ConversationProvider",
    );
  }
  return ctx;
}